export default __webpack_public_path__ + "static/media/my-sql.6b1cac8d.png";